import { FormControlLabel, FormControlLabelProps, Switch, SwitchProps } from '@material-ui/core';
import React, { forwardRef, useCallback } from 'react';

export interface AppCheckboxProps extends Omit<SwitchProps, 'value' | 'checked' | 'onBlur'> {
  label?: FormControlLabelProps['label'];
  value?: boolean;
  onBlur?: () => void;
  labelPlacement?: FormControlLabelProps['labelPlacement'];
}

export const AppSwitch = forwardRef<HTMLInputElement, AppCheckboxProps>(
  ({ value, label, labelPlacement = 'start', onChange, onBlur, ...rest }, ref) => {
    const handleChange = useCallback(
      (e: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
        if (!onChange) return;

        //@ts-ignore
        onChange({ ...e, target: { ...e.target, value: checked } }, checked);
      },
      [onChange],
    );
    return (
      <FormControlLabel
        control={
          <Switch
            color={'secondary'}
            inputRef={ref}
            checked={value}
            onChange={handleChange}
            onBlur={onBlur}
            {...rest}
          />
        }
        label={label}
        labelPlacement={labelPlacement}
      />
    );
  },
);
